import { LitElement, html } from 'lit';
import { customElement, state, property } from 'lit/decorators.js';
import { until } from 'lit/directives/until.js';
import callbackQueuePromise from '../../lib/callbackQueuePromise';
const clientConfigPromise = callbackQueuePromise('phxConfigQueue');

const OPEN_WEB_API = 'https://open-api.spot.im/v1/messages-count';
interface PhoenixOpenWebCommentsBtnProps {
    spotId: string;
    postId: string;
}

@customElement('phoenix-open-web-comments-button')
export default class PhoenixOpenWebCommentsBtn extends LitElement implements PhoenixOpenWebCommentsBtnProps {
    conversationEle: HTMLElement | null = document.querySelector('phoenix-open-web-conversation');
    features?: {
        isEnabled: (feature: string) => boolean;
    };

    @property({ type: String, attribute: 'spot-id' }) spotId!: string;
    @property({ type: String, attribute: 'post-id' }) postId!: string;
    @state() count: number = 0;

    private getMessageCounts() {
        return fetch(`${OPEN_WEB_API}?spot_id=${this.spotId}&posts_ids=${this.postId}`)
            .then((r) => r.json())
            .then(({ messages_count }) => {
                this.count = this.postId ? messages_count[this.postId] ?? 0 : 0;
            })
            .catch((e) => {
                // eslint-disable-next-line no-console
                console.error('Openweb Error: ', e);
            });
    }

    private formatNumber(value: number): string {
        const formatter = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 });
        if (Math.abs(value) < 1e3) return formatter.format(value);
        if (Math.abs(value) < 1e6) return formatter.format(value / 1e3) + 'k';
        if (Math.abs(value) < 1e9) return formatter.format(value / 1e6) + 'm';
        return value.toString();
    }

    connectedCallback(): void {
        super.connectedCallback();

        if (!this.spotId || !this.postId) {
            throw new Error('Attributes spot-id and post-id are required');
        }

        clientConfigPromise
            .then(({ features }) => {
                this.features = features;
            })
            .catch((err) =>
                // eslint-disable-next-line no-console
                console.error(err)
            );
    }

    handleClick(e: Event): void {
        e.preventDefault();
        document.documentElement.style.scrollBehavior = 'auto';
        window.location.hash = 'comments';
        this.conversationEle?.scrollIntoView();
        document.documentElement.style.scrollBehavior = '';

        if (this.features?.isEnabled('outbrain-block-feed-expansion')) {
            window.OBR?.extern?.blockFeedExpansion();
        }
    }

    render() {
        return html`${until(
            this.getMessageCounts().then(
                () => html`<a href="#" @click=${this.handleClick}>
                    <phx-svg-icon icon="ico_comments_openweb" class="m-social--open-web-icon"></phx-svg-icon>
                    ${this.count
                        ? html`<span>${this.formatNumber(this.count)}</span>
                              <span>${this.count === 1 ? 'Comment' : 'Comments'}</span>`
                        : html`<span>Start Conversation</span>`}
                </a>`
            ),
            html`<phx-loading-icon class="m-social--open-web-loader"></phx-loading-icon>`
        )}`;
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
    }

    protected createRenderRoot(): Element | ShadowRoot {
        return this;
    }
}
